<script setup lang="ts">
import { Checkmark24Regular, Dismiss24Regular } from '@vicons/fluent';
</script>

<template>
  <n-switch>
    <template #checked>
      Enabled
    </template>
    <template #checked-icon>
      <n-icon :component="Checkmark24Regular" />
    </template>
    <template #unchecked>
      <slot name="unchecked">
        Disabled
      </slot>
    </template>temp
    <template #unchecked-icon>
      <n-icon :component="Dismiss24Regular" />
    </template>
  </n-switch>
</template>